import {Image, isImage} from "./Image";
import TypeCheck from "../../utils/Typecheck";

export interface OptionAttribute {
    id: number
    title: string
    imagePreview: string
    imageFill: string
    image: Image
    filters: string[] | null
    group: string | null
    dependencies: Record<string, number[]> | null
    // example: "osnova:pa_logo_color": [123, 354]
    // example: "remen:pa_bagstrap_color": [123, 354]
}

export const isOptionAttribute = (content: unknown): content is OptionAttribute => {
    const isDependencies = (dependencies: object) => {
        const values = Object.values(dependencies)

        return values.every((value) => TypeCheck.isArrayOf(value, TypeCheck.isNumber));
    };

    return TypeCheck.isObject(content)
        && TypeCheck.hasAll(
            content,
            ['id', 'title', 'imagePreview', 'imageFill', 'image', 'filters', 'group', 'dependencies']
        )
        && TypeCheck.isNumber(content.id)
        && TypeCheck.isString(content.title)
        && TypeCheck.isString(content.imagePreview)
        && TypeCheck.isString(content.imageFill)
        && isImage(content.image)
        && (content.filters === null || TypeCheck.isArrayOf(content.filters, TypeCheck.isString))
        && TypeCheck.isStringOrNull(content.group)
        && (content.dependencies === null
            || (TypeCheck.isObject(content.dependencies) && isDependencies(content.dependencies)));
}
